import React from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';

type OnboardingStepPlaceholderProps = {
  title: string;
  subtitle?: string;
};

/**
 * Placeholder body for onboarding steps whose Figma designs aren't ready yet
 * (steps 2–4). Keeps the wizard navigable end-to-end until each step is built.
 */
export function OnboardingStepPlaceholder({ title, subtitle }: OnboardingStepPlaceholderProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Stack flex={1} align="center" justify="center" gap={scale(8)} style={styles.container}>
      <Text variant="Font Guardian App/Heading/Heading H6 18px" style={styles.title}>
        {title}
      </Text>
      {subtitle ? (
        <Text variant="Font Guardian App/Subtitle/Subtitle 14 Regular" style={styles.subtitle}>
          {subtitle}
        </Text>
      ) : null}
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  container: {
    paddingVertical: scale(80),
  },
  title: {
    color: colors['10'],
  },
  subtitle: {
    color: colors['6'],
  },
}));

export default OnboardingStepPlaceholder;
